(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["notification-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const mq = window.matchMedia('(max-width: 749px)');

  const init = () => {
    if (!mq.matches) return;
    const bar = document.querySelector('.notification-bar[data-speed]');
    if (!bar) return;
    const inner = bar.querySelector('.notification-bar__inner');
    if (!inner) return;
    const speed = parseInt(bar.dataset.speed, 10) || 4000;
    const items = Array.from(inner.querySelectorAll('.notification-bar__item'));
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      inner.appendChild(clone);
    });
    const duration = (speed / 1000) * items.length * 3;
    bar.style.setProperty('--nb-duration', duration + 's');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const scrollToNextSection = (slideDownArrow) => {
    const currentSection = slideDownArrow.closest('.shopify-section');
    if (!(currentSection instanceof HTMLElement)) return;

    let nextSection = currentSection.nextElementSibling;

    while (nextSection && !nextSection.classList.contains('shopify-section')) {
      nextSection = nextSection.nextElementSibling;
    }

    if (!(nextSection instanceof HTMLElement)) return;

    nextSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  document.addEventListener('click', (event) => {
    const slideDownArrow = event.target.closest('[data-slide-down-arrow]');
    if (!(slideDownArrow instanceof HTMLElement)) return;

    scrollToNextSection(slideDownArrow);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const slideDownArrow = event.target.closest('[data-slide-down-arrow]');
    if (!(slideDownArrow instanceof HTMLElement)) return;

    event.preventDefault();
    scrollToNextSection(slideDownArrow);
  });

  } catch(e) { console.error(e); }
})();
})();
